module.exports = __webpack_public_path__ + "static/img/arrow4.46befda.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/arrow4.png
// module id = fvQZ
// module chunks = 36